import React from 'react';
import SectionIncomingConsignment from '../SectionIncomingConsignment';

const TissueInwardConsignment = () => (
  <SectionIncomingConsignment
    sectionName="Tissue"
    sectionDisplayName="Tissue Section"
    backRoute="/sections/tissue"
  />
);

export default TissueInwardConsignment;
